import { useContext, useMemo } from "react";
import {
  DOMAIN,
  PERMISSION,
  useCanSendNationalCommitteeGroupEmailBool,
  useHasCapabilityBool
} from "@/hooks/useCapabilities";
import { AuthorizationContext } from "@/providers/AuthorizationProvider";
import { canAccessGroupEmail } from "./groupEmailScopes";

export function useCanAccessGroupEmail(): boolean {
  const { loaded, sectionLegacyIds, sectionLegacyIdsLoading } = useContext(AuthorizationContext);
  const canAccessNationalGroupEmail = useCanSendNationalCommitteeGroupEmailBool();
  const canViewPersonContact = useHasCapabilityBool({
    domain: DOMAIN.PEOPLE,
    permission: PERMISSION.viewPersonContact
  });

  return useMemo(
    () =>
      canAccessGroupEmail({
        canViewPersonContact,
        canAccessNationalGroupEmail,
        assignedSectionLegacyIds: sectionLegacyIds,
        loaded,
        sectionLegacyIdsLoading
      }),
    [canAccessNationalGroupEmail, canViewPersonContact, loaded, sectionLegacyIds, sectionLegacyIdsLoading]
  );
}
